// File: frontend/src/views/public/NotFound.js

import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/utility/SEO';
import { SEO_CONFIG } from '../../config/seo';

const NotFound = () => {
  const seo = SEO_CONFIG.notFound;

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.image}
        noindex={seo.noindex}
      />
      <div style={{ padding: '80px 40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '72px', margin: '0 0 16px 0' }}>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" style={{ color: '#1E3A8A', textDecoration: 'underline' }}>
          Go Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;